import { render, staticRenderFns } from "./DetailReading.vue?vue&type=template&id=08ae7120&scoped=true"
import script from "./DetailReading.vue?vue&type=script&lang=ts"
export * from "./DetailReading.vue?vue&type=script&lang=ts"
import style0 from "./DetailReading.vue?vue&type=style&index=0&id=08ae7120&lang=scss"
import style1 from "./DetailReading.vue?vue&type=style&index=1&id=08ae7120&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ae7120",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08ae7120')) {
      api.createRecord('08ae7120', component.options)
    } else {
      api.reload('08ae7120', component.options)
    }
    module.hot.accept("./DetailReading.vue?vue&type=template&id=08ae7120&scoped=true", function () {
      api.rerender('08ae7120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contents/mission/components/DetailReading.vue"
export default component.exports